import {useTranslation} from "react-i18next";

export default function ItemsTitle({title}){
  const {t} = useTranslation()
  
  return (
    <div className="bg-[#f9f9f9] px-[34px] py-[15px]
                    text-[16px] mdmax:hidden font-bold">
      {t(title)}
    </div>
  )
}
